import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./app.css";

ReactDOM.createRoot(document.getElementById("app")!).render(<App />);
